import React from 'react'
import { Col, Row } from 'reactstrap'

const CovidAntigenTesting = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 pt-md-5 py-4'>
            <div className='pb-3'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                    RT PCR & Rapid Antigen Testing In Chicago
                </div>
                <hr className='hr-style my-md-1' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                We strive to provide an efficient testing place for everyone. United Lab Care offers COVID testing services in Chicago; we provide free RT-PCR and Rapid Antigen testing in Chicago to our customers because testing has become a requirement for returning to your life, resuming your business, or traveling anywhere around the world.
                </div>
            </div>

            <div className='left-padding6rem right-padding6rem py-md-4'>
                <Row className=''>
                    <Col xs='12' sm='12' md='6' lg='4' className='flex-center pb-md-0 pb-5 p-0 pt-md-0 pt-4'>
                    <div className='bg-im flex-cent pb-5' style={{ backgroundColor:'#f2f2f2', height:'100%', width:'80%', backgroundRepeat:'no-repeat', paddingLeft:'', paddingTop:'', boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', borderRadius:'3rem'}}>
                    <center>
                    <div className='pt-5'>
                        <img src='covid-testing/PCR-Testing.png' alt='PCR-Testing' height='auto' width='55px' />
                    </div>
                    <div className='py-3'>
                        <div className='fs-ss-18 text-montserrat fw-700 text-ss-secondary' style={{ letterSpacing:'0.5px'}}>
                        Real Time - PCR<br/> Testing
                        </div>
                    </div>
                        <div className='px-4'>
                            <div className='fs-ss-15 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            The most efficient and high-quality RT-PCR Testing processed at our CLIA certified labs.
                            </div>
                        </div>
                        </center>
                    </div>
                    </Col>
                    <Col xs='12' sm='12' md='6' lg='4' className='flex-center pb-md-0 pb-5 p-0'>
                    <div className='bg-im flex-cent pb-5' style={{ backgroundColor:'#f2f2f2', height:'100%', width:'80%', backgroundRepeat:'no-repeat', paddingLeft:'', paddingTop:'', boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', borderRadius:'3rem'}}>
                    <center>
                    <div className='pt-5'>
                        <img src='covid-testing/Rapid-Antigen-Testing.png' alt='PCR-Testing' height='auto' width='55px' />
                    </div>
                    <div className='py-3'>
                        <div className='fs-ss-18 text-montserrat fw-700 text-ss-secondary' style={{ letterSpacing:'0.5px'}}>
                            Rapid Antigen<br/> Testing
                        </div>
                    </div>
                        <div className='px-4'>
                            <div className='fs-ss-15 text-montserrat fw-600 text-ss-black px-1' style={{ letterSpacing:'0.5px'}}>
                            The simplest and fastest method of determining the COVID-19.
                            </div>
                            <div className='fs-ss text-montserrat fw-600 text-ss-black pt-1' style={{ fontSize:'11px'}}>
                            (The RT-PCR tests can detect the virus better than the antigen tests, though no test is perfect.)
                            </div>
                        </div>
                        </center>
                    </div>
                    </Col>
                    <Col xs='12' sm='12' md='6' lg='4' className='flex-center p-0 pb-md-0 pb-4 pt-2 pt-md-5 pt-lg-0'>
                    <div className='bg-im flex-cent pb-5' style={{ backgroundColor:'#f2f2f2', height:'100%', width:'80%', backgroundRepeat:'no-repeat', paddingLeft:'', paddingTop:'', boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', borderRadius:'3rem'}}>
                    <center>
                    <div className='pt-5'>
                        <img src='covid-testing/Safety-Mangement.png' alt='PCR-Testing' height='auto' width='55px' />
                    </div>
                    <div className='py-3'>
                        <div className='fs-ss-18 text-montserrat fw-700 text-ss-secondary' style={{ letterSpacing:'0.5px'}}>
                        Workplace Safety<br/> Management
                        </div>
                    </div>
                        <div className='px-4'>
                            <div className='fs-ss-15 text-montserrat fw-600 text-ss-black px-2' style={{ letterSpacing:'0.5px'}}>
                                Exceptional services and end-to-end weekly onsite testing solutions.
                            </div>
                        </div>
                        </center>
                    </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default CovidAntigenTesting